import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteEachVendorExpenseQuery = (id) => {
  return axios.post(`${apiurl?.deleteEachVendorExpense}?vendorExpenseitemID=${id}`);
};

const deleteEachVendorExpense = () => {
  const queryClient = useQueryClient();
  return useMutation(['deleteEachVendorExpense'], deleteEachVendorExpenseQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getvendorlist');
    }
  });
};

export default deleteEachVendorExpense;
